import React, { useEffect } from "react";
import "./Skill.css";
import {
  FaLaptopCode,
  FaReact,
  FaNodeJs,
  FaPython,
  FaMicrosoft,
} from "react-icons/fa";
import { AiOutlineCloudServer, AiFillHtml5 } from "react-icons/ai";
import { BsClipboardData } from "react-icons/bs";
import { DiCss3Full, DiJqueryLogo, DiDatabase, DiDjango } from "react-icons/di";
import {
  SiJavascript,
  SiAnaconda,
  SiAdobephotoshop,
  SiAdobeillustrator,
} from "react-icons/si";
import { BiListPlus } from "react-icons/bi";
import { FiMoreHorizontal } from "react-icons/fi";
import { GiJupiter } from "react-icons/gi";

import AOS from "aos";
import "aos/dist/aos.css";

const Skill = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  return (
    <section className="skill" id="skill">
      <h2>Skills</h2>
      <div className="skills-container">
        <div className="skills frontend" data-aos="fade-up">
          <div className="skill-title">
            <h3>frontend</h3>
            <FaLaptopCode color={"#ee20d6"} size={50} />
          </div>
          <div className="skill-body">
            <ul>
              <li>
                <AiFillHtml5 className="skill-icon" color="#e34c26" /> html
              </li>
              <li>
                <DiCss3Full className="skill-icon" color="#364de4" />
                css{" "}
              </li>
              <li>
                <SiJavascript className="skill-icon" color="#f0db4f" />{" "}
                javascript
              </li>
              <li>
                <FaReact className="skill-icon" color="#61dbfb" /> reactJS and
                NextJS
              </li>
              <li>
                <DiJqueryLogo className="skill-icon" color="#0868ac" />
                jquery
              </li>
            </ul>
          </div>
        </div>
        <div className="skills backend " data-aos="fade-up">
          <div className="skill-title">
            <h3>backend</h3>
            <AiOutlineCloudServer color={"#ee20d6"} size={70} />
          </div>
          <div className="skill-body">
            <ul>
              <li>
                <FaNodeJs className="skill-icon" color="#68a063" size={20} />{" "}
                node & express
              </li>
              <li>
                <DiDjango className="skill-icon" color="#8993be" size={30} />
                Django{" "}
              </li>
              <li>
                <DiDatabase className="skill-icon" color="#000" /> sql & mongodb
              </li>
            </ul>
          </div>
        </div>
        <div className="skills data-science" data-aos="fade-up">
          <div className="skill-title">
            <h3> data science</h3>
            <GiJupiter color={"#ee20d6"} size={100} />
          </div>
          <div className="skill-body">
            <ul>
              <li>
                <FaPython className="skill-icon" color="#000" /> python
              </li>
              <li>
                <SiAnaconda className="skill-icon" color="#3eb049" />
                anaconda{" "}
              </li>
            </ul>
          </div>
        </div>
        <div className="skills others" data-aos="fade-up">
          <div className="skill-title">
            <h3>others</h3>
            <FiMoreHorizontal color={"#ee20d6"} size={50} />
          </div>
          <div className="skill-body">
            <ul>
              <li>
                <BsClipboardData className="skill-icon" color="#f0db4f" />{" "}
                microsoft power bi{" "}
              </li>
              <li>
                <FaMicrosoft className="skill-icon" color="blue" />
                microsoft office{" "}
              </li>
              <li>
                <SiAdobephotoshop className="skill-icon" color="#000" /> adobe
                photoshop
              </li>
              <li>
                <SiAdobeillustrator className="skill-icon " color="#000" />{" "}
                adobe illustrator
              </li>
              <li>
                <BiListPlus className="skill-icon" color="blue" />
                Eview
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skill;
